import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanSanctionUI from './LoanSanctionUI.js'

class LoanSanctionSF extends Component {
  constructor(props) {
    super(props)
    let sanction = this.props.loan.sanction

    let addendumFilename = ''
    if (this.props.loan.loanDocumentList) {
      let addendumDoc = this.props.loan.loanDocumentList.filter(d => d.code === 'addendum')
      if (addendumDoc.length)
        addendumFilename = addendumDoc[0].pdfFileName
    }

    this.state = {
      successMsg: null,
      errorList: null,
      //
      loanName: this.props.loan.loanName || '',
      loanNameError: null,
      //
      sanctionedAmount: this.props.loan.sanction.amountF || this.props.loan.termSheet.amountF || '',
      sanctionedAmountError: null,
      //
      sanctionedTenureMonths: this.props.loan.sanction.tenureMonths || this.props.loan.termSheet.tenureMonths || '',
      sanctionedTenureMonthsError: null,
      //
      interestTenureMonths: this.props.loan.sanction.interestMonths || '',
      interestTenureMonthsError: null,
      showInterestTenureMonths: this.props.loan.loanType == 'int_then_prj' || false,
      //
      sanctionedInterestRate: this.props.loan.sanction.interestRate || this.props.loan.termSheet.interestRate || '',
      sanctionedInterestRateError: null,
      //
      sanctionedAPR: this.props.loan.sanction.apr || '',
      sanctionedAPRError: null,
      //
      processingFee2F: this.props.loan.termSheet.processingFee2.amountWithoutTaxF3 || '',
      processingFee2FError: null,
      //
      promoterFundF3: this.props.loan.sanction.promoterFundF3 || '',
      promoterFundF3Error: null,
      //
      dsraPercent: '' + sanction.dsraPercent,
      dsraPercentError: null,
      //
      depositPercent: '' + sanction.depositPercent,
      depositPercentError: null,
      //
      specialTerms: this.props.loan.sanction.specialTerms || '',
      specialTermsError: null,
      //
      addendumFilename: addendumFilename,
      addendumFilenameError: null,
      //
      followUpLoan: this.props.loan.followUpLoan,
      //
      generate: false,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <LoanSanctionUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        loan={this.props.loan}
        //
        loanName={this.state.loanName}
        onLoanNameChange={(event) => {this.setState({loanName: event.target.value})}}
        loanNameError={this.state.loanNameError}
        setLoanNameError={(error) => {this.setState({loanNameError: error})}}
        //
        sanctionedAmount={this.state.sanctionedAmount}
        onSanctionedAmountChange={(event) => {this.setState({sanctionedAmount: event.target.value})}}
        sanctionedAmountError={this.state.sanctionedAmountError}
        setSanctionedAmountError={(error) => {this.setState({sanctionedAmountError: error})}}
        //
        sanctionedTenureMonths={this.state.sanctionedTenureMonths}
        onSanctionedTenureMonthsChange={(event) => {this.setState({sanctionedTenureMonths: event.target.value})}}
        sanctionedTenureMonthsError={this.state.sanctionedTenureMonthsError}
        setSanctionedTenureMonthsError={(error) => {this.setState({sanctionedTenureMonthsError: error})}}
        //
        interestTenureMonths={this.state.interestTenureMonths}
        onInterestTenureMonthsChange={(event) => {this.setState({interestTenureMonths: event.target.value})}}
        interestTenureMonthsError={this.state.interestTenureMonthsError}
        setInterestTenureMonthsError={(error) => {this.setState({interestTenureMonthsError: error})}}
        showInterestTenureMonths={this.state.showInterestTenureMonths}
        //
        sanctionedInterestRate={this.state.sanctionedInterestRate}
        onSanctionedInterestRateChange={(event) => {this.setState({sanctionedInterestRate: event.target.value})}}
        sanctionedInterestRateError={this.state.sanctionedInterestRateError}
        setSanctionedInterestRateError={(error) => {this.setState({sanctionedInterestRateError: error})}}
        //
        sanctionedAPR={this.state.sanctionedAPR}
        onSanctionedAPRChange={(event) => {this.setState({sanctionedAPR: event.target.value})}}
        sanctionedAPRError={this.state.sanctionedAPRError}
        setSanctionedAPRError={(error) => {this.setState({sanctionedAPRError: error})}}
        //
        processingFee2F={this.state.processingFee2F}
        onProcessingFee2FChange={this.onProcessingFee2FChange}
        processingFee2FError={this.state.processingFee2FError}
        setProcessingFee2FError={(error) => {this.setState({processingFee2FError: error})}}
        //
        promoterFundF3={this.state.promoterFundF3}
        onPromoterFundF3Change={(event) => {this.setState({promoterFundF3: event.target.value})}}
        promoterFundF3Error={this.state.promoterFundF3Error}
        setPromoterFundF3Error={(error) => {this.setState({promoterFundF3Error: error})}}
        //
        dsraPercent={this.state.dsraPercent}
        onDsraPercentChange={(event) => {this.setState({dsraPercent: event.target.value})}}
        dsraPercentError={this.state.dsraPercentError}
        setDsraPercentError={(error) => {this.setState({dsraPercentError: error})}}
        //
        depositPercent={this.state.depositPercent}
        onDepositPercentChange={(event) => {this.setState({depositPercent: event.target.value})}}
        depositPercentError={this.state.depositPercentError}
        setDepositPercentError={(error) => {this.setState({depositPercentError: error})}}
        //
        specialTerms={this.state.specialTerms}
        onSpecialTermsChange={(event) => {this.setState({specialTerms: event.target.value})}}
        specialTermsError={this.state.specialTermsError}
        setSpecialTermsError={(error) => {this.setState({specialTermsError: error})}}
        //
        addendumFilename={this.state.addendumFilename}
        onAddendumFilenameChange={(event) => {this.setState({addendumFilename: event.target.value})}}
        addendumFilenameError={this.state.addendumFilenameError}
        setAddendumFilenameError={(error) => {this.setState({addendumFilenameError: error})}}
        //
        followUpLoan={this.state.followUpLoan}
        onFollowUpLoanChange={(event) => {this.setState({followUpLoan: !this.state.followUpLoan})}}
        //
        generate={this.state.generate}
        onGenerateChange={(event) => {this.setState({generate: !this.state.generate})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onProcessingFee2FChange = (event) => {
    this.setState({
      processingFee2F: event.target.value,
    })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/sanction`,
      this.onSubmitCallback, {
        loanName: this.state.loanName,
        sanctionedAmountF: this.state.sanctionedAmount,
        sanctionedTenureMonths: this.state.sanctionedTenureMonths,
        interestTenureMonths: this.state.interestTenureMonths,
        sanctionedInterestRate: this.state.sanctionedInterestRate,
        sanctionedAPR: this.state.sanctionedAPR,
        processingFee2F: this.state.processingFee2F,
        promoterFundF: this.state.promoterFundF3,
        dsraPercent: this.state.dsraPercent,
        depositPercent: this.state.depositPercent,
        specialTerms: this.state.specialTerms,
        addendumFilename: this.state.addendumFilename,
        followUpLoan: this.state.followUpLoan,
        generate: this.state.generate,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'loanNameF':
          this.setState({loanNameError: error.message})
          break;
        case 'sanctionedAmountF':
          this.setState({sanctionedAmountError: error.message})
          break;
        case 'sanctionedTenureMonths':
          this.setState({sanctionedTenureMonthsError: error.message})
          break;
        case 'interestTenureMonths':
          this.setState({interestTenureMonthsError: error.message})
          break;
        case 'sanctionedInterestRate':
          this.setState({sanctionedInterestRateError: error.message})
          break;
        case 'sanctionedAPR':
          this.setState({sanctionedAPRError: error.message})
          break;
        case 'processingFee2F':
          this.setState({processingFee2FError: error.message})
          break;
        case 'promoterFundF3':
          this.setState({promoterFundF3Error: error.message})
          break;
        case 'dsraPercent':
          this.setState({dsraPercentError: error.message})
          break;
        case 'depositPercent':
          this.setState({depositPercentError: error.message})
          break;
        case 'specialTerms':
          this.setState({specialTermsError: error.message})
          break;
        case 'addendumFilename':
          this.setState({addendumFilenameError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    let context = this.props.context
    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
      setTimeout(() => {
        window.location.href = `/su/loans/${this.props.match.params.loanId}`
      }, 2000);
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

}

export default withRouter(LoanSanctionSF)
